/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_9b69181c"]'><div><div :class='["picker-demo-title"]'>basic-picker:</div><cube-date-picker ref="__mpx_ref_picker__" :min="(min)" :max="(max)" :value="(value)" @columnChange='(e)=>__invoke(e, [["onColumnChange"]])' @change='(e)=>__invoke(e, [["onChange"]])'/><div :class='["button-wrapper"]'><cube-button @_click="getSelected">获取当前选中项</cube-button></div><div :class='["demo-data"]' v-if="(selectedInfo.length || changeParams.length)"><template v-if="(selectedInfo.length)"><div :class='["key"]'>getSelectedInfo 事件返回值：</div><div :class='["value"]'><div v-for="(item, index) in (selectedInfo)" :key="item.index" :class='["value-item"]'><div :class='["item-key"]'>{{item[0]}}</div><div :class='["item-value"]'>{{item[1]}}</div></div></div></template><template v-if="(changeParams.length)"><div :class='["key"]'>columnChange 事件参数：</div><div :class='["value"]'><div v-for="(item, index) in (columnChangeParams)" :key="item.index"><div :class='["value-number"]'>第{{ index+1 }}次：</div><div v-for="(itemChild, index) in (item)" v-for-key='"itemIndex"' :key="itemChild.itemIndex" :class='["value-item"]'><div :class='["item-key"]'>{{itemChild[0]}}</div><div :class='["item-value"]'>{{itemChild[1]}}</div></div></div></div></template><template v-if="(changeParams.length)"><div :class='["key"]'>change 事件参数：</div><div :class='["value"]'><div v-for="(item, index) in (changeParams)" :key="item.index" :class='["value-item"]'><div :class='["item-key"]'>{{item[0]}}</div><div :class='["item-value"]'>{{item[1]}}</div></div></div></template></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_9b69181c"}'>
.picker-demo-title
  margin-bottom: 8px
.button-wrapper
  margin-top: 10px
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

  .key
    margin-bottom: 10px
    font-size: 16px
  .key-introduce
    margin-bottom: 10px
    line-height: 20px
  .value
    margin-bottom: 20px
    white-space: break-spaces
    .value-number
      margin-top: 20px
    .value-item
      display flex
      justify-content: space-between
      height: 25px
      line-height: 25px
      font-size: 15px
      .item-value
        margin-left: 10px
        white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_9b69181c"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_9b69181c"}
  /** script content **/
  require("./basic-picker.mpx.js?isComponent&outputPath=components%2Fbasic-picker9b69181c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./basic-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbasic-picker9b69181c%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_9b69181c"],
    ctorType: "component",
    outputPath: "components/basic-picker9b69181c/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-date-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/date-picker/index.mpx?isComponent&outputPath=components%2Findexc2f4660c%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>